import { r as registerInstance, h, e as Host } from './index-bfb2bce5.js';

const ttuiMetadataCss = ":host{display:block;text-align:right;padding:var(--half-gutter) var(--gutter)}";

const TtuiMetadata = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  render() {
    return (h(Host, null, h("slot", null)));
  }
};
TtuiMetadata.style = ttuiMetadataCss;

export { TtuiMetadata as ttui_metadata };

//# sourceMappingURL=ttui-metadata.entry.js.map